import React from 'react';
import { useSelector } from 'react-redux';

import { BasicInfo } from '../../components/BasicInfo';
import {
  getNewbuildingDisplayName,
  getSpecialStatusDisplay,
  getFullAddress,
  getUndergroundInfo,
  getRoadInfo,
  getRegionId,
  getIsSalesLeader,
  getSpecifications,
  getHousesByTurnDisplay,
  getHousesCount,
  getNewbuildingWebsite,
} from '../../selectors/newbuilding';

import { TransportAccessibilityEntryContainer } from '../TransportAccessibilityEntry';

export const BasicInfoContainer: React.FC = () => {
  const basic = {
    name: useSelector(getNewbuildingDisplayName),
    specialStatusDisplay: useSelector(getSpecialStatusDisplay),
    isSalesLeader: useSelector(getIsSalesLeader),
    website: useSelector(getNewbuildingWebsite),
  };

  const address = {
    fullAddress: useSelector(getFullAddress),
    regionId: useSelector(getRegionId),
    undergroundInfo: useSelector(getUndergroundInfo),
    roadInfo: useSelector(getRoadInfo),
  };

  const specifications = useSelector(getSpecifications);
  const housesByTurnDisplay = useSelector(getHousesByTurnDisplay);
  const housesCount = useSelector(getHousesCount);

  return (
    <BasicInfo
      basic={basic}
      address={address}
      specifications={specifications}
      housesByTurnDisplay={housesByTurnDisplay}
      housesCount={housesCount}
      transportAccessibility={<TransportAccessibilityEntryContainer />}
    />
  );
};
